import { render, staticRenderFns } from "./Bmqk.vue?vue&type=template&id=3fe5f09b&scoped=true"
import script from "./Bmqk.vue?vue&type=script&lang=js"
export * from "./Bmqk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5f09b",
  null
  
)

export default component.exports